import React from "react";
import { Box } from "digiwash-components";

interface PropTypes {
  isSelected?: boolean;
}

function CircleCheckmark(props: PropTypes) {
  let { isSelected = false } = props;

  return (
    <Box
      bg={isSelected ? "primary.main" : "common.white"}
      // width={24}
      // height={24}
      // alignItems="center"
      // justifyContent="center"
      // borderRadius="circle"
      br="circle"
      style={{
        borderColor: isSelected ? "#BAE6E9" : "#BAE6E9",
        borderWidth: 2,
        width: 16,
        height: 16,
      }}
    ></Box>
  );
}

export default CircleCheckmark;
